
import { Component, Prop, Vue } from 'vue-property-decorator';

import { sharedState } from '../../../../../../framework/state';
import { getResource, postResource } from '../../../../../../framework/client/resource';
import TextField from '../../../../../../framework/fields/TextField.vue';
import SelectField from '../../../../../../framework/fields/SelectField.vue';
import { PurchaseInvoiceRow } from '../../../../../../../common/application/model/PurchaseInvoiceRow';
import SwitchField from '../../../../../../framework/fields/SwitchField.vue';
import NumberField from '../../../../../../framework/fields/NumberField.vue';
import IntegerField from '../../../../../../framework/fields/IntegerField.vue';
import DateField from '../../../../../../framework/fields/DateField.vue';
import PercentageField from '../../../../../../framework/fields/PercentageField.vue';
import CurrencyAmountField from '../../../../../../framework/fields/CurrencyAmountField.vue';
import { ValidationObserver } from 'vee-validate';
import { getDatabaseOptions } from '../../../../../../framework/service/options';
import { PurchaseInvoice } from '../../../../../../../common/application/model/PurchaseInvoice';
import TextAreaField from '../../../../../../framework/fields/TextAreaField.vue';
import VendorContractSelect from '../../../../../fields/VendorContractSelect.vue';
import AutoCompleteField from '../../../../../../framework/fields/AutoCompleteField.vue';
import { ApplicationResource } from '../../../../../../../common/application/enumeration/ApplicationResource';
import { updateCachedResourceRow } from '../../../../../service/query_cache_service';
import { errorToast, successToast } from '../../../../../service/toast_service';
import { addPurchaseInvoiceRow } from '../../../../../../../browser/application/client/purchase_invoice_client';

@Component({
    components: {
        DateField,
        PercentageField,
        NumberField,
        CurrencyAmountField,
        SelectField,
        TextField,
        SwitchField,
        IntegerField,
        TextAreaField,
        ValidationObserver,
        VendorContractSelect,
        AutoCompleteField,
    },
})
export default class AddPurchaseInvoiceRow extends Vue {
    // Constants
    readonly resourceType = ApplicationResource.PURCHASE_INVOICE_ROW;

    // Properties
    @Prop(String) readonly purchaseInvoiceId!: string;

    // State
    shared = sharedState;
    local = {
        purchaseInvoice: {} as PurchaseInvoice,
        row: {} as PurchaseInvoiceRow,
        invoiceRowTypeOptions: [] as { id: string | undefined; label: string }[],
    };

    // Functions
    async mounted() {
        this.local.purchaseInvoice = (await getResource<PurchaseInvoice>(
            ApplicationResource.PURCHASE_INVOICE,
            this.purchaseInvoiceId,
        ))!!;
        this.local.row = {
            ...this.local.row,
            purchaseInvoiceId: this.local.purchaseInvoice.id,
            invoiceNumber: this.local.purchaseInvoice.invoiceNumber,
        };
        this.local.invoiceRowTypeOptions = await getDatabaseOptions('InvoiceRowType', this);
    }

    add() {
        this.addResource(true);
    }

    async addResource(goBack: boolean) {
        try {
            if (this.local.row.startDate > this.local.row.endDate) {
                throw new Error('Start date cannot be later than end date.')
            }

            const addedRow = await addPurchaseInvoiceRow(this.local.row)
            successToast(this, 'message.purchaseInvoiceRowSaved');
            updateCachedResourceRow<PurchaseInvoiceRow>(addedRow, addedRow.id, this.resourceType);

            if (goBack) {
                this.back();
            }
            }
        catch (error: any) {
            if(error instanceof Error) {
                errorToast(this, error.message);
            } else {
                errorToast(this, error);
            }
        }
    }

    back() {
        this.$router.go(-1);
    }
}
